module.exports = __webpack_public_path__ + "static/media/sara.4e831b46.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/equipe/sara.png
// module id = 2280
// module chunks = 0